// Fires one anonymous "search" analytics event per settled query — the raw term (server-side PII-scrubbed)
// + the result count (0 == searched & couldn't find). Feeds the admin insights panel + content-gap
// analysis. Identity is never sent (backend hashes it); errors are swallowed by the analytics pipeline.
// Shared by every search surface (modal, /search page, home hero) so the pool is uniform.
import { useEffect } from 'react';
import { useAnalytics } from '@backstage/core-plugin-api';

export function SearchLogger({ term, count }: { term: string; count: number }) {
  const analytics = useAnalytics();
  useEffect(() => {
    const q = term.trim();
    if (!q) return;
    analytics.captureEvent('search', q, { attributes: { count } });
  }, [term, count, analytics]);
  return null;
}
